export const CONN_KEYAS = 'https://appmobile.svurguns.cyou/Data';
// export const CONN_KEYAS = 'https://svurguns.com/Data';
// export const CONN_KEY = CONN_KEYAS + '/api/app/test/';

export const CONN_KEY = CONN_KEYAS + '/api/app123/';
// export const CONN_KEY = 'https://senategroup.az/Data/api/appBeledci/';C:\xampp\htdocs\dashboard\Apps\appback\api
export const CONN_KEY_version = '9.12.28';